<template>
  <div
    id="document-sidebar-foldertreelist"
    class="list-tree p-0 h-fit overflow-hidden"
  >
    <tree-template
      :folder="{
        name: vesselName,
        path: selectedItemId,
        isOpen: isOpen
      }"
      :switchOpenMethod="toggleSwitchOpen"
      :selectedMethod="toggleTreeSelect"
      :isSelected="isSelected"
    >
      <template #child>
        <folder-tree-item :folders="folders" />
      </template>
    </tree-template>
  </div>
</template>

<script>
import TreeTemplate from "../../../tree/DocumentFolderTemplate"
import FolderTreeItem from "./DocumentFolderTreeItem"
import { createNamespacedHelpers } from "vuex";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");



export default {
  name: "FolderTreeList",
  components: {
    TreeTemplate,
    FolderTreeItem,
  },
  data () {
    return {
      scrollSettings: {
        maxScrollbarLength: 20,
      },
      selectedItemId: "tree-root",
      isOpen: false
    }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "vesselName", "selectedSidebarItem", "folders", 
    ]),
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager([
      "fetchRootSidebarFolders",
      "setSidebarSelected"
    ]),
    toggleSwitchOpen () {
      this.isOpen = !this.isOpen;
    },
    async toggleTreeSelect () {
      try {
        this.$vs.loading();
        const payload = {
          selected: this.selectedItemId,
          showPath: false,
          showFolder: true
        }
        await this.setSidebarSelected(payload)
        this.isOpen = true;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.error(error)
        throw error
      }
    },
    isSelected (path) {
      return this.selectedSidebarItem === path
    }
  },
  mounted () {
    this.fetchRootSidebarFolders()
  },
  created () {
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/document-manager.scss";

</style>